import { render, staticRenderFns } from "./AspectImg.vue?vue&type=template&id=6e49f194&scoped=true"
import script from "./AspectImg.vue?vue&type=script&lang=js"
export * from "./AspectImg.vue?vue&type=script&lang=js"
import style0 from "./AspectImg.vue?vue&type=style&index=0&id=6e49f194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e49f194",
  null
  
)

export default component.exports